import "./AddSchool.css";
import React, { Fragment } from "react";
import AddSchoolViewModel from "./AddSchoolViewModel";
import ReactSelect from "../../../../Components/Select/React-Select";

const AddSchool = () => {
  const {
    RegisterSchool,
    FormDisabled,
    AddSchool,
    setAddSchool,
    SchoolIDError,
    SchoolNameError,
    HeadOfSchoolError,
    SchoolStartDateError,
    InstitutionTypeError,
    SchoolEmailError,
    SchoolUrlError,
    UploadFile,
    SchoolAddressError,
    IsUpdate,
  } = AddSchoolViewModel();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-school-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">
                  {IsUpdate ? "Update School" : "Add School"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="departments.html">School</a>
                  </li>
                  <li className="breadcrumb-item active">Add School</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>School Details</span>
                        </h5>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            School Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              SchoolNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                SchoolName: e.target.value,
                              });
                            }}
                            value={AddSchool.SchoolName}
                            disabled={FormDisabled}
                          />
                          {SchoolNameError === true ? (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                School name is required and cannot be less than
                                3 characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                School name is required and cannot be less than
                                3 characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            School Registration No{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              SchoolIDError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                SchoolRegistrationNo: e.target.value,
                              });
                            }}
                            value={AddSchool.SchoolRegistrationNo}
                            disabled={FormDisabled}
                          />
                          {SchoolIDError === true ? (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                School Registration No is required
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                School Registration No is required
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Head of School{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              HeadOfSchoolError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                HeadOfSchool: e.target.value,
                              });
                            }}
                            value={AddSchool.HeadOfSchool}
                            disabled={FormDisabled}
                          />
                          {HeadOfSchoolError === true ? (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Head of school is required and cannot be less
                                than 3 characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Head of school is required and cannot be less
                                than 3 characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Institution Type{" "}
                            <span className="register-danger">*</span>
                          </label>

                          <ReactSelect
                            handleChange={(value) => {
                              setAddSchool({
                                ...AddSchool,
                                InstitutionType: value,
                              });
                            }}
                            options={[
                              {
                                value: "please select type",
                                label: "please select type",
                                isDisabled: true,
                              },
                              { value: "school", label: "School" },
                            ]}
                            disabled={FormDisabled}
                            error={InstitutionTypeError === true}
                          />
                          {/* <select
                            className={`form-control ${
                              InstitutionTypeError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                InstitutionType: e.target.value,
                              });
                            }}
                            disabled={FormDisabled}
                          >
                            <option disabled selected>
                              Please Select{" "}
                            </option>
                            <option value="school">School</option>
                          </select>
                          <i className="fa-solid fa-caret-down institution-type-select-drop-down-icon"></i> */}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms ">
                          <label>
                            School Start Date{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="date"
                            placeholder="DD-MM-YYYY"
                            className={`form-control ${
                              SchoolStartDateError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                SchoolStartDate: e.target.value,
                              });
                            }}
                            value={AddSchool.SchoolStartDate}
                            disabled={FormDisabled}
                          />
                          {SchoolStartDateError === true ? (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                School's start date is required{" "}
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                School's start date is required
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms ">
                          <label>
                            School Email
                            <span className="login-danger">*</span>
                          </label>

                          <input
                            type="email"
                            className={`form-control ${
                              SchoolEmailError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                SchoolEmail: e.target.value,
                              });
                            }}
                            value={AddSchool.SchoolEmail}
                            disabled={FormDisabled}
                          />
                          {SchoolEmailError === true ? (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                valid email:abc@xyz.com
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                valid email:abc@xyz.com
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms ">
                          <label>Web site</label>
                          <input
                            type="email"
                            className={`form-control `}
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                SchoolWebsite: e.target.value,
                              });
                            }}
                            value={AddSchool.SchoolWebsite}
                            disabled={FormDisabled}
                          />

                          <span className="admin-add-school-tooltip">
                            <i className="fa-solid fa-info text-info"></i>
                            <span className="tooltip-text">
                              If school have website then enter the website URL
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms ">
                          <label>
                            Url <span className="login-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${
                              SchoolUrlError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                SchoolUrl: e.target.value,
                              });
                            }}
                            value={AddSchool.SchoolUrl}
                            disabled={FormDisabled}
                          />
                          {SchoolUrlError === true ? (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Unique Name(slug) that represent school
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                School slug is required
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms ">
                          <label>
                            School Address{" "}
                            <span className="login-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${
                              SchoolAddressError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddSchool({
                                ...AddSchool,
                                SchoolAddress: e.target.value,
                              });
                            }}
                            value={AddSchool.SchoolAddress}
                            disabled={FormDisabled}
                          />
                          {SchoolAddressError === true ? (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                School's start date is required{" "}
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-school-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                School's start date is required
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group  students-up-files">
                          <label>School Logo</label>
                          <div className="uplod">
                            <label className="file-upload image-upbtn mb-0">
                              Choose File{" "}
                              <input
                                type="file"
                                onChange={(e) => {
                                  UploadFile(e.target.files[0]);
                                }}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="student-submit">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              RegisterSchool();
                            }}
                            disabled={FormDisabled}
                          >
                            {IsUpdate ? "Update" : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddSchool;
